import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.scss']
})
export class PerfilComponent implements OnInit {

  public user = this.authSvc.afAuth.user;
  usuario: any;
  perfil: any;
  nombre: string;
  email: string;
  cedula: string;
  telefono: string;
  usrType: string;
  idUser: string;
  name = false;
  cdl = false;
  mail = false;
  tel = false;
  nNombre: string;
  nCedula: string;
  nEmail: string;
  nTelefono: string;
  constructor(private authSvc: AuthService) { }

  ngOnInit(): void {
    this.user.subscribe(usr => {
      this.usuario = usr;
      this.idUser = this.usuario.uid;
      this.authSvc.consultarTipoUsuario(this.idUser)
      .subscribe(res => {
        this.perfil = res;
        const tipo = this.perfil.tipo;
        this.nombre = this.perfil.nombre;
        this.email = this.perfil.email;
        this.cedula = this.perfil.cedula;
        this.telefono = this.perfil.telefono;
        this.usrType = tipo;
      });
    });
  }

  activateUpdate(item: string){
    if (item === 'name') {
      this.name = true;
      this.cdl = false;
      this.mail = false;
      this.tel = false;
    }
    if (item === 'cdl') {
      this.name = false;
      this.cdl = true;
      this.mail = false;
      this.tel = false;
    }
    if (item === 'mail') {
      this.name = false;
      this.cdl = false;
      this.mail = true;
      this.tel = false;
    }
    if (item === 'tel') {
      this.name = false;
      this.cdl = false;
      this.mail = false;
      this.tel = true;
    }
  }

  nuevoNombre(event: string){
    this.nNombre = event;
  }
  nuevoCedula(event: string){
    this.nCedula = event;
  }
  nuevoEmail(event: string){
    this.nEmail = event;
  }
  nuevoTelefono(event: string){
    this.nTelefono = event;
  }

  actualizaDatos(){
    if (this.name) {
      this.authSvc.actualizaNombreUsuario(this.idUser, this.nNombre);
    }
    if (this.cdl) {
      this.authSvc.actualizaCedulaUsuario(this.idUser, this.nCedula);
    }
    if (this.mail) {
      this.authSvc.actualizaEmailUsuario(this.idUser, this.nEmail);
    }
    if (this.tel) {
      this.authSvc.actualizaTelefonoUsuario(this.idUser, this.nTelefono);
    }
  }
}
